import { useState } from "react";

export function EditIcon({ onClick }) {
  const [hovered, setHovered] = useState(false);

  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      onMouseEnter={() => setHovered(true)}
      onMouseLeave={() => setHovered(false)}
      onClick={onClick}
      style={{ cursor: "pointer" }}
      id="edit-icon"
    >
      <path
        d="M21 7.18939L16.8107 3.00003C16.6714 2.86074 16.5061 2.75024 16.3241 2.67486C16.1421 2.59947 15.947 2.56067 15.75 2.56067C15.553 2.56067 15.358 2.59947 15.176 2.67486C14.994 2.75024 14.8287 2.86074 14.6894 3.00003L12.2198 5.46957L12.2197 5.46971L12.2195 5.46985L3.43941 14.25C3.29967 14.3889 3.18888 14.5542 3.11345 14.7363C3.03803 14.9184 2.99947 15.1136 3.00001 15.3107V19.5C3.00046 19.8977 3.15864 20.279 3.43985 20.5602C3.72105 20.8414 4.10232 20.9996 4.50001 21H8.68937C8.88643 21.0006 9.08164 20.962 9.2637 20.8866C9.44576 20.8112 9.61105 20.7004 9.75001 20.5607L21.0001 9.31067C21.2809 9.02914 21.4387 8.6477 21.4386 8.25002C21.4386 7.85235 21.2809 7.47091 21 7.18939ZM18 10.1894L13.8107 6.00003L15.75 4.06067L19.9394 8.25003L18 10.1894Z"
        fill={hovered ? "#fca119ff" : "#FCC068"}
        style={{ transition: "all 0.3s ease-out" }}
      />
    </svg>
  );
}
